export default __webpack_public_path__ + "static/media/logo.a8bf76dc.png";